import type { FC } from 'react';
import styled from 'styled-components';
import type { Match, WrestlerInMatch } from '../../../types';
import { BoxFourWrestlersContainer, BoxWinnerGeneric, DefaultContainerCard, TopDecorColor } from './GenericComponentCssMatchCard';
import CenterInfoFightComponentRender from './GenericComponentMatchCard';

const BoxWrestler = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    width: calc(50% - 30px);

    & .name-wrestler {
        font-size: 16px;
        font-weight: 500;
        margin: 0;
        text-transform: uppercase;
        width: 100%;
        padding: 0 30px;
        // spazio caratteri
        letter-spacing: 5px;
        // se supera il width va a capo
        white-space: normal;
        overflow-wrap: break-word;
    }

    &.box-wrestler.right .name-wrestler {
        text-align: right;
        justify-content: flex-end;
    }
`;

const AvatarWrestler = styled.div`
    position: relative;
    width: 100px;
    height: 100px;
    border: 2px solid rgba(163, 27, 27, 0.45);
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        border-color: rgba(163, 27, 27, 0.85);
        transform: scale(1.1);
    }

    & img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
    }
`;

interface ThreeTagMatchCardProps {
    matchInfo: Match;
    keyMatchInfo: number | string;
    navigateToWrestler: (wrestler: WrestlerInMatch) => void;
}

const ThreeTagMatchCard: FC<ThreeTagMatchCardProps> = ({ matchInfo, keyMatchInfo, navigateToWrestler }) => {
    // prendo props.match.wrestlers_by_team e lo divido in due array uguale.. se dispari, il primo array avra' un elemento in più
    const teamsWrestlers = matchInfo.wrestlers_by_team || [];
    const teamWrestlers1 = teamsWrestlers.slice(0, Math.ceil(teamsWrestlers.length / 2));
    const teamWrestlers2 = teamsWrestlers.slice(Math.ceil(teamsWrestlers.length / 2));

    // Renderizza un singolo wrestler
    const renderSingleWrestler = (wrestler: WrestlerInMatch, key: number, side: 'left' | 'right') => {
        if (side === 'left') {
            return (
                <BoxWrestler className={`box-wrestler ${side}`} key={key}>
                    <AvatarWrestler className="avatar-wrestler"
                        onClick={() => navigateToWrestler(wrestler)}
                    >
                        <img src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} />

                        {wrestler.pivot.is_winner ? (
                            <BoxWinnerGeneric className="box-winner-generic-w-100">
                                <span className="winner-text">WIN</span>
                                {matchInfo.win_by_dq ?
                                    <span className="by-dq">BY DQ</span>
                                : null}
                            </BoxWinnerGeneric>
                        ) : null}
                    </AvatarWrestler>
                    <h6 className="name-wrestler">{wrestler.name}</h6>
                </BoxWrestler>
            );
        } else {
            return (
                <BoxWrestler className={`box-wrestler ${side}`} key={key}>
                    <h6 className="name-wrestler">{wrestler.name}</h6>
                    <AvatarWrestler className="avatar-wrestler"
                        onClick={() => navigateToWrestler(wrestler)}
                    >
                        <img src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} />
                        {wrestler.pivot.is_winner ? (
                            <BoxWinnerGeneric className="box-winner-generic-w-100">
                                <span className="winner-text">WIN</span>
                                {matchInfo.win_by_dq ?
                                    <span className="by-dq">BY DQ</span>
                                : null}
                            </BoxWinnerGeneric>
                        ) : null}
                    </AvatarWrestler>
                </BoxWrestler>
            );
        }
    };


    // JSX
    return (
        <DefaultContainerCard
         key={keyMatchInfo}
         style={{
            paddingLeft: '30px',
            paddingRight: '30px'
        }}>
            <TopDecorColor />

            <BoxFourWrestlersContainer className="box-four-wrestlers-container-left">
                {teamWrestlers1.map((teamWrestler, idx) => (
                    teamWrestler.map((wrestler, key) => (
                        renderSingleWrestler(wrestler, key, 'left')
                    ))
                ))}

                {/* {matchInfo.wrestlers_by_team[1].map((wrestler, key) => (
                    renderSingleWrestler(wrestler, key, 'left')
                ))} */}
            </BoxFourWrestlersContainer>

            <CenterInfoFightComponentRender
                className="center-info-fight-component-render-four-vs-four"
                nameMatch={matchInfo.type_match?.type || ''}
                matchInfo={matchInfo}
            />

            <BoxFourWrestlersContainer className="box-four-wrestlers-container-right">
                {teamWrestlers2.map((teamWrestler, idx) => (
                    teamWrestler.map((wrestler, key) => (
                        renderSingleWrestler(wrestler, key, 'right')
                    ))
                ))}
            </BoxFourWrestlersContainer>
        </DefaultContainerCard>
    );
};

export default ThreeTagMatchCard;
